import { businessKey } from 'queryKeys';

export const API_INTEGRATION = 'api-integration';
const apiIntegratioQuery = businessKey.query(API_INTEGRATION);

export const grids = apiIntegratioQuery.grids();
export const grid = apiIntegratioQuery.grid();

export const details = apiIntegratioQuery.details();
export const model = apiIntegratioQuery.exact();

export const mutations = apiIntegratioQuery.mutations();

export const remove = mutations.create();
export const create = mutations.create();
export const update = mutations.update();
